import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import { Database } from '@/_constants/database.types';

type AttemptAnswer = Database['public']['Tables']['past_paper_attempt_answers']['Row'];

const useAttemptAnswers = (attemptId: string | undefined) => {
  return useQuery({
    queryKey: ['past_paper_attempt_answers', attemptId],
    queryFn: async (): Promise<AttemptAnswer[]> => {
      if (!attemptId) return [];

      const { data, error } = await supabaseClient
        .from('past_paper_attempt_answers')
        .select('*')
        .eq('attempt_id', attemptId)
        .order('created_at', { ascending: true });

      if (error) throw error;

      return data || [];
    },
    enabled: !!attemptId,
  });
};

export default useAttemptAnswers;
